import { Text, type TextProps } from '@vizit/atoms';
import { headingClasses } from './styles';
import { HeadingVariant } from './types';

interface HeadingProps extends Omit<TextProps, 'elementType' | 'isCompact' | 'size' | 'variant'> {
  /**
   * The render variant of the heading.
   *
   * @optional
   * @type 'h1' | 'h2' | 'h3' | 'h4' | 'eyebrow'
   * @default 'h1'
   */
  variant?: HeadingVariant;
}

/**
 * The Heading component is used to display a heading.
 *
 * @param props - The props for the Heading component.
 * @example
 * <Heading variant={HeadingVariant.H1}>
 *   Heading Text
 * </Heading>
 */
function Heading(props: HeadingProps) {
  const { className, variant = HeadingVariant.H1, ...other } = props;

  const elementType = variant === HeadingVariant.Eyebrow ? 'p' : variant;

  return (
    <Text role="heading" className={headingClasses({ variant, className })} elementType={elementType} {...other} />
  );
}

export { Heading };
export type { HeadingProps };
